import { BreakpointArray } from '@thg-commerce/gravity-theme'

export interface BannerThemeInterface {
  textColSpan: BreakpointArray<number>
  layout: {
    maxWidth: string
  }
}

export const BANNER_WIDGET_THEME: BannerThemeInterface = {
  textColSpan: [24, 16, 10, 10],
  layout: {
    maxWidth: '100%',
  },
}
